import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CategoryService } from 'projects/qcloud-rest-client/src/lib/category.service';
import { TaxIntegrationClientService } from 'projects/qcloud-rest-client/src/lib/tax-integration-client.service';

@Component({
  selector: 'app-tax-integration-config',
  templateUrl: './tax-integration-config.component.html',
  styleUrls: ['./tax-integration-config.component.css']
})
export class TaxIntegrationConfigComponent implements OnInit {

  constructor(private taxClient: TaxIntegrationClientService,
    private categoryService: CategoryService,
    private translate: TranslateService,
    private toastr: ToastrService) { }
  maps: any[];
  categories: any[];
  ngOnInit(): void {
    this.categoryService.getCategories((data) => {
      this.categories = data;
    },
      () => { });
    this.taxClient.getTaxIntegrationMaps(data => {
      this.maps = data;
    }, () => { });
  }

  public addNewMap() {
    this.maps.push({});
  }

  public saveMaps() {
    this.taxClient.replaceTaxIntegrationMaps(this.maps, () => {
      this.translate.get('amms-maps-success').subscribe((msg: string) => {
        this.toastr.success("", msg);
      });
      this.taxClient.getTaxIntegrationMaps(data => {
        this.maps = data;

      }, () => { })
    }, () => {
      this.translate.get('amms-maps-error').subscribe((error: string) => {
        this.translate.get('repeat').subscribe((res: string) => {
          this.toastr.success(res, error);
        });
      });
    });
  }

  public removeMap(index: number) {
    this.maps.splice(index, 1);
  }
}
